import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/pro-solid-svg-icons';
import * as React from 'react';

export const LinkIcon = ({ color = '' }) => {
  const styleObj: React.CSSProperties = !!color ? { color } : {};
  return <FontAwesomeIcon style={styleObj} icon={faLink} size="sm" />;
};
